export const UPDATE_CONSENT_TEXT = 'update_consent_text'
export const SIGN_CONSENT = 'sign_consent'
export const CHECK_TERMS = 'check_terms'

export const initialConsentState: ConsentState = {
  consentText: '',
  isConsentSigned: false,
  isTermsChecked: false,
}
